export default "__VITE_ASSET__9Igtwy9N__"